module.exports = __webpack_public_path__ + "img/top_img07.5763b01d.png";